<template>
  <div class="total-table-wrap">
    <table class="total-table">
      <tbody>
      <tr class="subtitle">
        <td class="subtitle-text">Jacket Attributes</td>
        <td align="right" class="price">Price</td>
      </tr>
      <tr class="position">
        <td class="position-title">Jacket Style: <span class="position-mod">
          {{ jacketType }}
        </span></td>
        <td class="position-price" align="right">$<span>{{ jacketPrice }}</span></td>
      </tr>
      <tr class="position">
        <td class="position-title">Jacket Size:
          <span v-if="sizeSelected === 1" class="position-mod">
          {{ SIZES_VALUES.XS }}
          </span>
          <span v-if="sizeSelected === 2" class="position-mod">
          {{ SIZES_VALUES.S }}
          </span>
          <span v-if="sizeSelected === 3" class="position-mod">
          {{ SIZES_VALUES.M }}
          </span>
          <span v-if="sizeSelected === 4" class="position-mod">
          {{ SIZES_VALUES.L }}
          </span>
          <span v-if="sizeSelected === 5" class="position-mod">
          {{ SIZES_VALUES.XL }}
          </span>
          <span v-if="sizeSelected === 6" class="position-mod">
          {{ SIZES_VALUES.XXL }}
          </span>
          <span v-if="sizeSelected === 7" class="position-mod">
          {{ SIZES_VALUES.XXXL }}
          </span>
          <span v-if="sizeSelected === 8" class="position-mod">
          {{ SIZES_VALUES.XXXXL }}
          </span>
        </td>
        <td class="position-price" align="right">$<span>{{ oversizePrice }}</span></td>
      </tr>
      <tr class="position">
        <td class="position-title">Sleeve Length:
          <span v-if="sleeveLengthSelected === 1" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.SHORTEN_1 }}
          </span>
          <span v-if="sleeveLengthSelected === 2" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.SHORTEN_2 }}
          </span>
          <span v-if="sleeveLengthSelected === 3" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.SHORTEN_3 }}
          </span>
          <span v-if="sleeveLengthSelected === 4" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_1}}
          </span>
          <span v-if="sleeveLengthSelected === 5" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_2}}
          </span>
          <span v-if="sleeveLengthSelected === 6" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_3}}
          </span>
        </td>
        <td class="position-price" align="right">
          $<span>{{ sleeveLengthPrice }}</span></td>
      </tr>
      <tr class="position">
        <td class="position-title">Body Length: <span class="position-mod">
          <span v-if="bodyLengthSelected === 1" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.SHORTEN_1 }}
          </span>
          <span v-if="bodyLengthSelected === 2" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.SHORTEN_2 }}
          </span>
          <span v-if="bodyLengthSelected === 3" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.SHORTEN_3 }}
          </span>
          <span v-if="bodyLengthSelected === 4" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_1}}
          </span>
          <span v-if="bodyLengthSelected === 5" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_2}}
          </span>
          <span v-if="bodyLengthSelected === 6" class="position-mod">
          {{ BODY_SLEEVE_LENGTH_VALUES.LENGTHEN_3}}
          </span>
        </span></td>
        <td class="position-price" align="right">
          $<span>{{ bodyLengthPrice }}</span></td>
      </tr>
      <tr class="position">
        <td class="position-title">Zippered Hood</td>
        <td class="position-price" align="right">$<span>{{ zipperHoodPrice }}</span></td>
      </tr>
      <tr class="position">
        <td v-if="liningSelected === LINING_VALUES.QUILT_LINING"
            class="position-title">{{ LINING_VALUES.QUILT_LINING }}</td>
        <td v-if="liningSelected === LINING_VALUES.NYLON_LINING"
            class="position-title">{{ LINING_VALUES.NYLON_LINING }}</td>
        <td class="position-price" align="right">$<span>{{ liningPrice }}</span></td>
      </tr>
      <tr v-if="patches.ids.length > 0" class="subtitle">
        <td class="subtitle-text">Patch Information</td>
        <td align="right" class="price">Price</td>
      </tr>
      <tr v-for="id in patches.ids" :key="id" class="position">
        <td class="position-title">{{ patches.data[id].name }}</td>
        <td class="position-price" align="right">
          $<span>{{ patches.data[id].patchSize.sellingPrice }}</span></td>
      </tr>
      <tr v-if="projectInserts.length > 0" class="subtitle">
        <td class="subtitle-text">Insert Information</td>
        <td align="right" class="price">Price</td>
      </tr>
      <tr v-for="insert in projectInserts" :key="insert.id" class="position">
        <td class="position-title">{{ insert.name }}</td>
        <td class="position-price" align="right">
          $<span>{{insert.sellingPrice}}</span></td>
      </tr>
      <tr class="subtitle total-price">
        <td class="subtitle-text">Total</td>
        <td align="right" class="price">$<span>{{ totalPrice }}</span></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  BODY_SLEEVE_LENGTH_VALUES,
  LINING_VALUES, SIZES_VALUES
} from '@/common/constants';

export default {
  name: 'FinalizeOrderTable',
  components: {
  },
  data () {
    return {
      patchInfo: [
      ],
      LINING_VALUES,
      SIZES_VALUES,
      BODY_SLEEVE_LENGTH_VALUES
    };
  },
  props: {
    sizeSelected: Number || null,
    sleeveLengthSelected: Number,
    bodyLengthSelected: Number,
    snapStyleSelected: String || null,
    liningSelected: String || null,
  },
  created () {
    if (this.sizes.ids.length === 0) {
      this.$store.dispatch('elements/loadPatchSizes');
    }
  },
  computed: {
    projectInserts () {
      return this.$store.getters['design/getProjectInserts'];
    },
    sizes () {
      return this.$store.getters['elements/getSizesOfPatches'];
    },
    patches () {
      return this.$store.getters['design/getProjectPatches'];
    },
    jacketType () {
      return this.$store.getters['design/getJacketType'];
    },
    jacketPrice () {
      return this.$store.getters['finalizeOrder/getJacketPrice'];
    },
    oversizePrice () {
      return this.$store.getters['finalizeOrder/getOversizePrice'];
    },
    sleeveLengthPrice () {
      return this.$store.getters['finalizeOrder/getSleeveLengthPrice'];
    },
    bodyLengthPrice () {
      return this.$store.getters['finalizeOrder/getBodyLengthPrice'];
    },
    zipperHoodPrice () {
      return this.$store.getters['finalizeOrder/getZipperHoodPrice'];
    },
    liningPrice () {
      return this.$store.getters['finalizeOrder/getLiningPrice'];
    },
    totalPrice () {
      return this.$store.getters['finalizeOrder/getTotalPrice'];
    }
  },
};
</script>

<style scoped>
.total-table-wrap {
  flex: 1;
}
.total-table {
  width: 100%;
  border-collapse: collapse;
}
.subtitle {
  background-color: #464646;
  color: #fff;
  line-height: 2;
}

.subtitle-text, .price {
  font-size: 16px;
  font-weight: bold;
}

.subtitle-text, .position-title {
  padding-left: 10px;
}

.price, .position-price{
  padding-right: 10px;
}

.position {
  line-height: 2;
}

.position-title, .position-price {
  font-size: 14px;
}

</style>
